export class UserModel {
  public Id = 0;
  public Name: string;
  public LastName: string;
  public PhoneNumber: any;
  public PhoneNumberConfirmed: string;
  public Email: string;
  public EmailConfirmed: string;
  public UserName: string;
  public PasswordHash: string;
  public PasswordHashNew: string;
  public PasswordHashNewAgain: string;
  public SessionKey: string;
  public IsActive: boolean = true;
  public IsVbtAdmin: boolean = false;
  public Logo: string;
  public TokenLifeSpan: number = 60;
  public TokenRefreshSpan: number = 30;

  public constructor() {
    this.UserName = '';
  }
}

